import React from 'react';
import { Link } from 'react-router-dom';

import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Checkbox as AntdCheckbox,
  Dropdown as AntdDropdown,
  Menu as AntdMenu,
} from 'antd';

import { useModal } from 'hooks/modal/useModal';

import { views } from '../../Faq/utils';
import ModalCreation from '../../FaqDomaine/Modals/Creation/ModalCreation';

import './DashboardHeader.less';

interface DasboardHeaderFaqDomainProps {
  valid: boolean;
  setValid: (state: boolean) => void;
  refreshDashboard: () => void;
}

function DashboardHeader({
  valid,
  setValid,
  refreshDashboard,
}: DasboardHeaderFaqDomainProps): React.ReactElement {
  const modalCreation = useModal();

  const onRefreshDashboard = () => {
    refreshDashboard();
  };
  const menu = (
    <AntdMenu>
      {views.map((view, index) => (
        <AntdMenu.Item key={index}>
          <Link to={view.link} target="_blank">
            {view.label}
          </Link>
        </AntdMenu.Item>
      ))}
    </AntdMenu>
  );

  return (
    <div>
      <div className="dashboard-header-fields">
        <AntdCheckbox checked={!valid} onChange={_ => setValid(!valid)}>
          Afficher les domaines inactifs
        </AntdCheckbox>
        <div>
          <AntdButton
            type="primary"
            shape="round"
            className="createFaqDomainButton"
            onClick={modalCreation.open}
          >
            <PlusOutlined /> Créer un nouveau domaine
          </AntdButton>
          <AntdDropdown overlay={menu}>
            <AntdButton type="default" shape="default">
              Visualiser FAQ <DownOutlined />
            </AntdButton>
          </AntdDropdown>
        </div>
        <ModalCreation
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={onRefreshDashboard}
        />
      </div>
    </div>
  );
}

export default DashboardHeader;
